module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0005.jpg?v=8042368a";